(() => {
  const headerGroup = document.getElementById('header-group');
  if (!headerGroup) return;

  const normalizeLabels = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes('Lack Lacken')) {
        node.nodeValue = node.nodeValue.replaceAll('Lack Lacken', 'Lack Laken');
      }
    }
  };

  normalizeLabels(headerGroup);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const addedNode of mutation.addedNodes) {
        if (addedNode.nodeType === Node.TEXT_NODE) {
          if (addedNode.nodeValue?.includes('Lack Lacken')) {
            addedNode.nodeValue = addedNode.nodeValue.replaceAll('Lack Lacken', 'Lack Laken');
          }
        } else if (addedNode.nodeType === Node.ELEMENT_NODE) {
          normalizeLabels(addedNode);
        }
      }
    }
  });

  observer.observe(headerGroup, { childList: true, subtree: true });
})();
